import { AxiosError } from "axios";

import { TErrorMessages, TRegistrationResponseError } from "../types";
import { FIELD_NAMES } from "./constants";

const mapLoginErrorsToMessages = (errorResponse: AxiosError<TRegistrationResponseError>): TErrorMessages => {
  if (!errorResponse.response) {
    return { errorMessage: undefined, fieldErrors: undefined };
  }
  const { data } = errorResponse.response;
  const errorMessage = data?.title;
  const errorDetails = data?.detail;

  const fieldErrors = {
    [FIELD_NAMES.EMAIL]: errorDetails?.email,
    [FIELD_NAMES.FULL_NAME]: errorDetails?.fullName,
    [FIELD_NAMES.MOBILE_NUMBER]: errorDetails?.phone,
    [FIELD_NAMES.PASSWORD]: errorDetails?.password,
    [FIELD_NAMES.PASSWORD_REPEAT]: errorDetails?.repeatedPassword,
  };

  return { errorMessage, fieldErrors };
};
export default mapLoginErrorsToMessages;
